import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const DocumentsLabel = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 13px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  margin-top: ${barnesTheme.spacing.sectionGap};

  @media print {
    font-size: 13px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    margin-top: ${barnesTheme.spacing.sectionGap} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DocumentList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const DocumentCard = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid ${barnesTheme.colors.border};
  box-sizing: border-box;

  &:last-child {
    border-bottom: none;
  }

  @media print {
    display: flex !important;
    align-items: center !important;
    padding: 16px 0 !important;
    border-bottom: 1px solid ${barnesTheme.colors.border} !important;
    box-sizing: border-box !important;

    &:last-child {
      border-bottom: none !important;
    }
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DocumentIcon = styled.div`
  width: 16px;
  height: 20px;
  background: ${barnesTheme.colors.border};
  margin-right: 12px;
  flex-shrink: 0;

  @media print {
    width: 16px !important;
    height: 20px !important;
    background: ${barnesTheme.colors.border} !important;
    margin-right: 12px !important;
    flex-shrink: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TypeBadge = styled.div<{ $type: 'pdf' | 'image' }>`
  width: 16px;
  height: 20px;
  background: ${barnesTheme.colors.border};
  margin-right: 12px;
  flex-shrink: 0;

  @media print {
    width: 16px !important;
    height: 20px !important;
    background: ${barnesTheme.colors.border} !important;
    margin-right: 12px !important;
    flex-shrink: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DocumentInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
`

export const DocumentTitle = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.medium};
  font-weight: ${barnesTheme.fontWeights.normal};
  color: ${barnesTheme.colors.primary};

  @media print {
    font-size: ${barnesTheme.fontSizes.medium} !important;
    font-weight: ${barnesTheme.fontWeights.normal} !important;
    color: ${barnesTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DocumentSubtitle = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-size: ${barnesTheme.fontSizes.small} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DocumentDate = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  text-align: right;
  flex-shrink: 0;

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    text-align: right !important;
    flex-shrink: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  color: ${barnesTheme.colors.textLight};
  font-size: 12px;
  display: flex;
  align-items: center;

  @media print {
    display: none !important;
  }
`

export const ConfidentialityNote = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-top: ${barnesTheme.spacing.sectionGap};
  line-height: 1.6;

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: ${barnesTheme.spacing.sectionGap} !important;
    line-height: 1.6 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const UploadArea = styled.div`
  width: 100%;
  height: 80px;
  border: 2px dashed ${barnesTheme.colors.border};
  background: ${barnesTheme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: ${barnesTheme.spacing.contentGap};
  cursor: pointer;

  @media print {
    display: none !important;
  }
`

export const UploadIcon = styled.div`
  font-size: 18px;
  color: ${barnesTheme.colors.textLight};
  margin-bottom: 4px;

  @media print {
    display: none !important;
  }
`

export const UploadText = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};

  @media print {
    display: none !important;
  }
`

/* ── Upload dialog modal ──────────────────────────────────────────── */

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  @media print {
    display: none !important;
  }
`

export const DialogBox = styled.div`
  background: ${barnesTheme.colors.white};
  width: 420px;
  max-width: 90vw;
  padding: 32px;
  box-sizing: border-box;
  font-family: ${barnesTheme.fonts.body};
`

export const DialogTitle = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 16px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  margin-bottom: 24px;
`

export const DialogLabel = styled.label`
  display: block;
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.normal};
  color: ${barnesTheme.colors.text};
  margin-bottom: 6px;
`

export const DialogInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.medium};
  border: 1px solid ${barnesTheme.colors.border};
  outline: none;
  box-sizing: border-box;
  margin-bottom: 16px;

  &:focus {
    border-color: ${barnesTheme.colors.primary};
  }
`

export const DialogTextarea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.medium};
  border: 1px solid ${barnesTheme.colors.border};
  outline: none;
  box-sizing: border-box;
  margin-bottom: 20px;
  resize: vertical;
  min-height: 60px;

  &:focus {
    border-color: ${barnesTheme.colors.primary};
  }
`

export const DialogButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`

export const DialogCancelButton = styled.button`
  padding: 8px 20px;
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.normal};
  background: none;
  border: 1px solid ${barnesTheme.colors.border};
  color: ${barnesTheme.colors.text};
  cursor: pointer;
`

export const DialogConfirmButton = styled.button`
  padding: 8px 20px;
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.bold};
  background: ${barnesTheme.colors.primary};
  border: none;
  color: ${barnesTheme.colors.white};
  cursor: pointer;
`

/* Legacy exports kept for backward compatibility */
export const PreviewGrid = styled.div`
  display: none;

  @media print {
    display: none !important;
  }
`

export const PreviewCard = styled.div`
  display: none;
`

export const PreviewImage = styled.img`
  display: none;
`

export const FullPageImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;

  @media print {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
  }
`

export const FullPageImageContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10mm;
  box-sizing: border-box;

  @media print {
    flex: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 10mm !important;
    box-sizing: border-box !important;
  }
`
